import { Typography, Switch } from '@ui/components';
import { useTranslation } from 'react-i18next';
import { JSX, FC } from 'react';
import { cn } from '@ui/utils';
import React from 'react';

interface ServiceContainerProps {
  toggleDisabled?: boolean;
  children: JSX.Element;
  className?: string;
  icon: JSX.Element;
  active: boolean;
  title: string;
  previewData: {
    value: string;
    key: string;
  }[];
  onActiveChange: (active: boolean) => void;
}

export const ServiceContainer: FC<ServiceContainerProps> = (props) => {
  const { onActiveChange, toggleDisabled, className, children, active, title, icon } = props;
  const { t } = useTranslation();

  const Icon = React.cloneElement(icon, { className: 'size-6 text-weak' });

  return (
    <div
      className={cn(
        'rounded-xl p-4',
        {
          'outline outline-surface': active,
          'bg-body': !active,
        },
        className,
      )}
    >
      <div className="flex items-center gap-2">
        {Icon}
        <Typography variant="h200">{title}</Typography>

        <div className="flex items-center gap-4 ml-auto">
          <Typography variant="labelMediumBook" className="lowercase">
            {active ? t('COMPANY_POLICY.ACTIVE') : t('COMPANY_POLICY.INACTIVE')}
          </Typography>

          <Switch onCheckedChange={onActiveChange} disabled={toggleDisabled} checked={active} />
        </div>
      </div>

      {children}
    </div>
  );
};
